import { render, staticRenderFns } from "./brokerInfo.vue?vue&type=template&id=55234e86"
import script from "./brokerInfo.vue?vue&type=script&lang=js"
export * from "./brokerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports